import React from "react"
import { connect } from "react-redux";
import "./CheckBox.scss";

function CheckBox(props) {
    
    const {clicked, onClick} = props;

    return(
        <div 
            className="custom-checkbox" 
            onClick={(event)=> {if (onClick) onClick(event) }}
        >
            <input
                type="checkbox"
                checked={clicked}
                readOnly
            />
            <div className="custom-checkbox-style-2" />
        </div>
    )
} 

const mapStateToProps = state => {
    return {
        lang: state.language,
    }

};

export default connect (mapStateToProps)(CheckBox);